import {useState, createContext} from "react";

const User = createContext()

export default User